import { render, staticRenderFns } from "./oldmetalinStorageHistory.vue?vue&type=template&id=389453e9&scoped=true&"
import script from "./oldmetalinStorageHistory.vue?vue&type=script&lang=js&"
export * from "./oldmetalinStorageHistory.vue?vue&type=script&lang=js&"
import style0 from "./oldmetalinStorageHistory.vue?vue&type=style&index=0&id=389453e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389453e9",
  null
  
)

export default component.exports